export const NORMAL = 'normal'
export const MEDIUM = 'medium'
export const MEDIUM_STRONG = 'medium_strong'
export const STRONG = 'strong'
export const VERY_STRONG = 'very_strong'
// export const TEST_STRONG = 'test_strong'
